import { SvgIconTypeMap } from '@automata/mui-theme';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import ToggleButton, { ToggleButtonProps } from '@mui/material/ToggleButton';
import Tooltip from '@mui/material/Tooltip';

type Props = ToggleButtonProps & {
  title: string;
  value: string;
  disabled: boolean;
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
    muiName: string;
  };
};

export const UndoRedoButton = ({
  title,
  value,
  disabled,
  icon: Icon,
  ...toggleButtonProps
}: Props): JSX.Element => {
  const button = (
    <ToggleButton {...toggleButtonProps} value={value} disabled={disabled}>
      <Icon color={disabled ? 'disabled' : 'neutral'} />
    </ToggleButton>
  );

  if (disabled) return button;

  return (
    <Tooltip title={title} placement="right">
      {button}
    </Tooltip>
  );
};
